export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_fa104f57ae74ab8cca74927d